<!-- フォールスルーでclassなどを渡すため、ボタンタグをルートにする -->
<b-button
  @mousedown="onMousedown($event)"
  @mouseup="onMouseup($event)"
  @mouseleave="onMouseLeave"
>
  <!-- 子コンポーネントをそのまま表示 -->
  <slot />
</b-button>
